import { useToast } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { getUploadedMasterList } from 'api/auth.api';

const getErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg?.message) return msg.message;
  return fallback;
};

export const useUploadedMasterList = () => {
  const toast = useToast();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['uploadedMasterList'],
    queryFn: () => getUploadedMasterList(),
    select: (res) => res?.data || {},
    onError: (error) => {
      toast({
        title: getErrorMessage(error, 'Failed to fetch list'),
        status: 'error',
      });
    },
  });

  return {
    masterListData: data?.result || [],
    isLoading: isLoading || isFetching,
  };
};
